import React from 'react'
import { useTranslation } from 'react-i18next';
import { Row, Col, Badge, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import Icon from '@mdi/react';
import {
    mdiFaceMan,
    mdiFaceWoman,
    mdiCheckDecagramOutline,
    mdiAlertCircleOutline
} from '@mdi/js';

import './ParentListItem.css';

const ParentListItem = ({ parent, actions, selected, className, condensed }) => {
    const { t } = useTranslation();

    if (condensed)
        className = (className || '') + ' condensed';

    const color = selected ? 'info' : 'light';
    return (
        <Card className={ `ParentListItem ${className}` } color={color}>
            <CardBody>
                <Row className="mb-0">
                    <Col className="col-auto bg-light">
                        <CardText>
                            <Icon path={ parent.gender === 'F' ? mdiFaceWoman : mdiFaceMan } size={1} />&nbsp;
                        </CardText>
                    </Col>
                    <Col>
                        <CardText>
                            <strong>{ parent.lastname }&nbsp;{ parent.firstname }</strong>
                        </CardText>
                    </Col>
                    <Col>
                        <CardText>
                            { parent.phone }
                        </CardText>
                    </Col>
                    { actions && (
                    <Col className="col-auto">
                        <div className="actions">
                            { actions }
                        </div>
                    </Col>
                    )}
                </Row>
            </CardBody>
        </Card>
    )
}

export default ParentListItem;
